import { queryOptions } from '@tanstack/react-query';
import { ApiError } from '~/components/Providers/APIClient';
import { apiQueryFn } from '../utils';
import {
    ModeratorLeaderboardStatsRow,
    RecordLevelStatsRow,
    SubmissionsDailyStatsResponse,
    SubmissionsLevelStatsRow,
} from '~/util/types/stats';
import {
    dailyStatsParams,
    moderatorLeaderboardParams,
} from '~/routes/_authenticated/staff/stats/-SearchParams';

export const recordLevelStatsQuery = ({
    list,
}: {
    list: 'classic' | 'platformer';
}) =>
    queryOptions<RecordLevelStatsRow[], ApiError>({
        queryKey: ['statistics', 'level_records', list],
        queryFn: apiQueryFn<RecordLevelStatsRow[]>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/statistics/records`,
            method: 'GET',
        }),
    });

export const submissionLevelStatsQuery = ({
    list,
}: {
    list: 'classic' | 'platformer';
}) =>
    queryOptions<SubmissionsLevelStatsRow[], ApiError>({
        queryKey: ['statistics', 'level_submissions', list],
        queryFn: apiQueryFn<SubmissionsLevelStatsRow[]>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/statistics/submissions`,
            method: 'GET',
        }),
    });

export const submissionDailyStatsQuery = ({
    list,
    reviewer,
    ...pageFilters
}: {
    list: 'classic' | 'platformer';
} & dailyStatsParams) =>
    queryOptions<SubmissionsDailyStatsResponse, ApiError>({
        queryKey: [
            'statistics',
            'daily',
            list,
            reviewer,
            pageFilters?.page,
            pageFilters?.per_page,
        ],
        queryFn: apiQueryFn<SubmissionsDailyStatsResponse>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/statistics/submissions/daily`,
            method: 'GET',
            query: {
                reviewer_id: reviewer ?? undefined,
                ...pageFilters,
            },
            attachAuth: true,
        }),
    });

export const moderatorLeaderboardStatsQuery = ({
    list,
    ...filters
}: {
    list: 'classic' | 'platformer';
} & moderatorLeaderboardParams) =>
    queryOptions<ModeratorLeaderboardStatsRow[], ApiError>({
        queryKey: [
            'statistics',
            'moderator_leaderboard',
            list,
            filters.since,
            filters.until,
            filters.only_active,
            filters.include_hidden_reviewers,
            filters.reviewer_id,
        ],
        queryFn: apiQueryFn<ModeratorLeaderboardStatsRow[]>({
            path: `/${list === 'classic' ? 'aredl' : 'arepl'}/statistics/submissions/daily/leaderboard`,
            method: 'GET',
            query: filters,
            attachAuth: true,
        }),
    });
